const BLOCKED_NUMBER_KEYS = new Set(['e', 'E', '+', '-', '.'])

export function preventNumberInputWheelChange(event) {
  event.currentTarget.blur()
}

export function preventInvalidNumberKeyDown(event) {
  if (BLOCKED_NUMBER_KEYS.has(event.key)) {
    event.preventDefault()
  }
}

export function handleDigitsOnlyChange(onChange) {
  return (event) => {
    const sanitized = event.target.value.replace(/\D/g, '')
    if (event.target.value !== sanitized) {
      event.target.value = sanitized
    }
    onChange(event)
  }
}

export function handleNotDigitsOnlyChange(onChange) {
  return (event) => {
    const { value } = event.target
    if (value.trim() && /^\d+$/.test(value.trim())) {
      return
    }
    onChange(event)
  }
}
